/** Query-key factory for the team domain. */
export const teamKeys = {
  today: ['team', 'today'] as const,
  crews: ['team', 'crews'] as const,
  events: ['team', 'events'] as const,
  eventsToday: () => [...teamKeys.events, 'today'] as const,
  eventsList: (query: { from: string; to: string }) =>
    [...teamKeys.events, 'list', query] as const,
};
